import SensorRegister from './SensorRegister';
import { compose } from 'redux';
import { withRouter, useParams } from 'react-router';
import { connect, useSelector } from 'react-redux';
import IPADInventoryContainer from './iPad/Container';
import GPSInventoryContainer from './GPS/Container';
import { fetchOrgs, addOrg, updateOrg } from '../../modules/orgs/actions';
import { AppState } from '../../store';
import { InventoryType } from '../../modules/inventory/types';
import EspAqInventoryContainer from './ESP_AQ/Container';
import FoobotInventoryContainer from './Foobot/Container';
import PumpsInventoryContainer from './Pumps/Container';
import SimcardInventoryContainer from './Simcards/Container';

function InventoryTypeContainer() {
  const { inventoryType } = useParams<{ inventoryType: string }>();
  switch (inventoryType) {
    case 'sensors':
      return <SensorRegister />;
    case InventoryType.IPAD:
      return <IPADInventoryContainer />;
    case InventoryType.GPS:
      return <GPSInventoryContainer />;
    case InventoryType.FOOBOT:
      return <FoobotInventoryContainer />;
    case InventoryType.MACHINE_ACTIVITY:
      return <EspAqInventoryContainer key={InventoryType.MACHINE_ACTIVITY} type={InventoryType.MACHINE_ACTIVITY} />;
    case InventoryType.ESP_AQ:
      return <EspAqInventoryContainer key={InventoryType.ESP_AQ} />;
    case InventoryType.PUMP:
      return <PumpsInventoryContainer />;
    case InventoryType.SIM_CARDS:
      return <SimcardInventoryContainer />;

    default:
      return <SensorRegister />;
  }
}

function mapStateToProps(state: AppState) {
  return {
    loading: false,
    orgs: state.orgs.orgs,
    // @ts-ignore
    uid: state.user.details.uid,
    // @ts-ignore
    email: state.user.details.email,
  };
}

const mapActionsToProps = {
  fetchOrgs,
  addOrg,
  updateOrg,
};

const withConnect = connect(mapStateToProps, mapActionsToProps);

export default compose(withConnect, withRouter)(InventoryTypeContainer);
